export default __webpack_public_path__ + "static/media/yellow_car.b971a395.png";